// extracted by mini-css-extract-plugin
module.exports = {"ProductCardListWrapper":"ProductCardList_ProductCardListWrapper__Jjee3","ProductCardList":"ProductCardList_ProductCardList__nCtBk"};